var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBurner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 4.875C16.875 4.875 16.125 7.875 14.25 7.875C10.125 7.875 11.625 1.125 11.625 1.125C11.625 1.125 7.875 3.375 6.75 9.375C5.25 8.625 4.875 6.375 4.875 6.375C4.875 6.375 2.625 9 2.625 13.125C2.625 21 10.125 21.75 10.125 21.75C10.125 21.75 8.25 19.5 8.25 16.875C8.25 12.75 10.011 10.875 10.011 10.875C10.011 10.875 10.386 15 12.75 15C14.25 15 15 13.875 15 13.875C15 13.875 16.5 15.375 16.5 18C16.5 20.3805 14.625 21.75 14.625 21.75C18.5542 20.9603 21.375 17.3288 21.375 13.1768C21.375 8.25 16.875 4.875 16.875 4.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBurner);
export default __webpack_public_path__ + "static/media/icon-burner.dd4798ef58f15cfc3cbec811ec46f812.svg";
export { ForwardRef as ReactComponent };